namespace $.$$ {

	export class $shm_prereleasefixtureapp extends $.$shm_prereleasefixtureapp {

		message() {
			return this.$.$shm_prereleasefixtureshared_message()
		}

	}

}
